import type { ComponentType } from 'react';

import type { WidgetConfig } from '@/config/dashboard.types';
import { WIDGET_TYPES, type WidgetType } from '@/config/widget-types';

import { AccessDiscoveryWidget } from './AccessDiscoveryWidget';
import { FilesCoveredWidget } from './FilesCoveredWidget';
import { HumanIdentitiesWidget } from './HumanIdentitiesWidget';
import { NonHumanIdentitiesWidget } from './NonHumanIdentitiesWidget';
import { SensitivityWidget } from './SensitivityWidget';
import { StaleDuplicateDataWidget } from './StaleDuplicateDataWidget';
import { TopDataAccessedWidget } from './TopDataAccessedWidget';
import { TopIdentitiesWidget } from './TopIdentitiesWidget';

export interface WidgetComponentProps {
  config: WidgetConfig;
}

/**
 * Component registry for every known widget type. `WidgetGrid` dispatches
 * through this map, so adding a new widget type is: add it to `WIDGET_TYPES`,
 * create the component file, add an entry here. TypeScript enforces the map
 * is exhaustive via `Record<WidgetType, ...>`.
 */
export const WIDGETS: Record<WidgetType, ComponentType<WidgetComponentProps>> = {
  [WIDGET_TYPES.AccessDiscovery]: AccessDiscoveryWidget,
  [WIDGET_TYPES.FilesCovered]: FilesCoveredWidget,
  [WIDGET_TYPES.HumanIdentities]: HumanIdentitiesWidget,
  [WIDGET_TYPES.NonHumanIdentities]: NonHumanIdentitiesWidget,
  [WIDGET_TYPES.Sensitivity]: SensitivityWidget,
  [WIDGET_TYPES.StaleDuplicateData]: StaleDuplicateDataWidget,
  [WIDGET_TYPES.TopDataAccessed]: TopDataAccessedWidget,
  [WIDGET_TYPES.TopIdentities]: TopIdentitiesWidget,
};
